import React from 'react';
import InfoItem from '../InfoItem';
import PropTypes from 'prop-types';

function InfoCard({ startDate, endDate, createDate, userImage, userName }) {
    return (
        <div className="col-md-5">
            <div className="row">
                <div className="col-lg-6">
                    <InfoItem
                        isAvatar={true}
                        avatar={userImage}
                        heading={'Created By'}
                        subHeading={userName}
                    />
                </div>
                <div className="col-lg-6">
                    <InfoItem heading={'Create Date'} subHeading={createDate} />
                </div>
            </div>
            <hr className="mt-4 mb-5" />
            <div className="row">
                <div className="col-lg-6">
                    <InfoItem heading={'Start Date'} subHeading={startDate} />
                </div>
                <div className="col-lg-6">
                    <InfoItem heading={'End Date'} subHeading={endDate} />
                </div>
            </div>
        </div>
    );
}

InfoCard.propTypes = {
    // start date to display
    startDate: PropTypes.string,
    // create date to display
    createDate: PropTypes.string,
    // end date to display
    endDate: PropTypes.string,
    // user name to display
    userName: PropTypes.string,
    // user image to display
    userImage: PropTypes.string,
};

InfoCard.defaultProps = {
    startDate: '',
    endDate: '',
    createDate: '',
    userName: '',
    userImage: '',
};

export default InfoCard;
